import React from 'react';

import PageSection from 'components/PageSection';

import { useAPI } from 'api';
import PropEditor from 'components/PropEditor';
import RawJsonDisplay from 'components/RawJsonDisplay';
import { WorkspaceFirewallState, FirewallInfo, FirewallGroup } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

const WorkspaceFirewallSettings = () => {
	const api = useAPI();

	const ctx = useOrgContext();

	const [workspaceFirewall, setWorkspaceFirewall] = React.useState<WorkspaceFirewallState>({
		firewallID: null,
		firewallGroup: null
	});

	const [availableFirewalls, setAvailableFirewalls] = React.useState<FirewallInfo[]>([]);
	const [availableFirewallGroups, setAvailableFirewallGroups] = React.useState<FirewallGroup[]>([]);

	const loadWorkspaceFirewall = () => {
		api.get<WorkspaceFirewallState>(`${ctx?.apiBaseWorkspace}/overrides/firewall`)
		.then(json => setWorkspaceFirewall(json));
	};

	const saveWorkspaceFirewall = () => {
		api.post(`${ctx?.apiBaseWorkspace}/overrides/firewall`, workspaceFirewall)
		.then(() => {
			loadWorkspaceFirewall();
		});
	};

	const saveWorkspaceFirewallForce = () => {
		api.post(`${ctx?.apiBaseWorkspace}/overrides/firewall`, workspaceFirewall)
		.then(() => {
			loadWorkspaceFirewall();
		});
	};

	const loadFirewalls = () => {
		api.get<FirewallInfo[]>(`${ctx?.apiBaseTenant}/firewalls`)
		.then(json => setAvailableFirewalls(json));
	};

	const loadFirewallGroups = () => {
		if (!workspaceFirewall.firewallID) {
			return setAvailableFirewallGroups([]);
		}

		api.get<FirewallGroup[]>(`${ctx?.apiBaseTenant}/firewalls/${workspaceFirewall.firewallID}/firewallgroups`)
		.then(json => setAvailableFirewallGroups(json));
	};

	React.useEffect(() => {
		loadFirewalls();
		loadWorkspaceFirewall();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	React.useEffect(() => {
		loadFirewallGroups();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [workspaceFirewall]);

	return (
		<div>
			<PageSection level={3} title="Firewall">
				<PropEditor<WorkspaceFirewallState>
					object={workspaceFirewall}
					props={[
						{ label: 'Firewall', key: 'firewallID', type: 'select', options: [{ value: '', label: '(none)' }].concat(availableFirewalls.map(firewall => ({ label: firewall.name, value: firewall.id }))) },
						{ label: 'Firewall Group', key: 'firewallGroup', type: 'select', options: [{ value: '', label: '(none)'}].concat(availableFirewallGroups.map(group => ({ label: group.name, value: group.id }))) },
					]}
					onChange={setWorkspaceFirewall}
				/>

				<p>
					<button onClick={saveWorkspaceFirewall}>Save Firewall</button>
					<button onClick={saveWorkspaceFirewallForce}>Save Firewall (Force)</button>
				</p>
			</PageSection>

			<PageSection level={4} title="Raw Data">
				<RawJsonDisplay data={workspaceFirewall} />
			</PageSection>
		</div>
	);
}

export default WorkspaceFirewallSettings;
